<template>
  <div class="wrapper" >
    <div class="text-area" @click="showkeyboard($event)">
      <p v-if="!show && !value.length" class="placeholder">{{ placeholder }}</p>
      <p v-else>{{ value }}</p>
    </div>
    <transition name="popup" mode="out-in">
      <div class="keyboard-wrapper" v-if="show" id="number-x-keyboard">
        <div class="btn-finish"><span>确定</span></div>
        <div class="keyboard">
          <div class="key" data-val="1">
            <a href="javascript:;" class="keycap">1</a>
          </div>
          <div class="key" data-val="2">
            <a href="javascript:;" class="keycap" data-val="2">2</a>
          </div>
          <div class="key" data-val="3">
            <a href="javascript:;" class="keycap" data-val="3">3</a>
          </div>
          <div class="key" data-val="4">
            <a href="javascript:;" class="keycap" data-val="4">4</a>
          </div>
          <div class="key" data-val="5">
            <a href="javascript:;" class="keycap" data-val="5">5</a>
          </div>
          <div class="key" data-val="6">
            <a href="javascript:;" class="keycap" data-val="6">6</a>
          </div>
          <div class="key" data-val="7">
            <a href="javascript:;" class="keycap" data-val="7">7</a>
          </div>
          <div class="key" data-val="8">
            <a href="javascript:;" class="keycap" data-val="8">8</a>
          </div>
          <div class="key" data-val="9">
            <a href="javascript:;" class="keycap" data-val="9">9</a>
          </div>
          <div class="key" data-val="X">
            <a href="javascript:;" class="keycap" data-val="X">X</a>
          </div>
          <div class="key" data-val="0">
            <a href="javascript:;" class="keycap" data-val="0">0</a>
          </div>
          <div class="key" data-val="del">
            <a href="javascript:;" class="keycap del-key" data-val="del"></a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    maxlength: {
      type: Number,
      default: 18,
    },
    placeholder: {
      type: String,
      default: '请输入',
    },
    value: {
      type: [String, Number],
    },
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    showkeyboard() {
      // if (this.show) {
      //   return
      // }
      this.show = !this.show
    },
    handleClick(e) {
      let path = e.path || (e.composedPath && e.composedPath()) || ''
      let classList = path.map(el => el.className)
      if (classList.includes('keyboard')) {
        if (e.target.getAttribute('data-val')) {
					e.target.classList.add('active')
          let val = e.target.getAttribute('data-val')
          if (val === 'del') {
            val = this.value.substring(0, this.value.length - 1)
          }else{
            if(this.value.length < this.maxlength){
              val = this.value + val
            }else{
              val = this.value
            }
					}
					this.$emit('input', val)
					setTimeout(()=>{
						e.target.classList.remove('active')
					},100)
        }     
      } else {
        if (!classList.includes('text-area') && this.show) {
          this.show = false
           e.preventDefault()
        }
      }      
    },
  },
  mounted() {
    document
      .getElementsByTagName('body')[0]
      .addEventListener('touchend', this.handleClick,true)
  },
  beforeDestroy() {
    document
      .getElementsByTagName('body')[0]
      .removeEventListener('touchend',this.handleClick,true)
  },
}
</script>
<style lang="stylus" scoped>
@import '../styles/variable.styl';

.wrapper {
  flex: 1 1 auto;
}

.text-area {
  width: 100%;
  outline: none;
  border: none;
  box-sizing: border-box;
  display: inline-block;
  font-size: $ucar_font_h4;
  text-align: right;
  line-height: 1.6;
  background-color: transparent;
  padding: 24px 40px 24px 0px;
	word-break: break-all;
	word-wrap:break-word;
  .placeholder {
    color: #999;
  }
}
.btn-finish{
	text-align: center;
  padding: 0 30px;
  font-size: 34px;
  line-height: 80px;
  height: 80px;
  color:#ff9c00;
  text-align :right;
}

.keyboard-wrapper {
  // height:250px;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  z-index: 999;

  .keyboard {
    display: flex;
    flex-wrap: wrap;

    .key {
      box-sizing: border-box;
      height: 120px;
      width: 33.33%;
      float: left;
      border-right: 1px solid #d6d6d6;
      border-top: 1px solid #d6d6d6;
      display: flex;
      align-items: center;
      justify-content: center;
			&.active{
				background-color:#d1d5db;
				.del-key{
						background-color:#fff;
				}
			}
      a {
        display: inline-block;
        text-decoration: none;
        font-size: 45px;
        font-weight: 450;
        color: inherit;
        overflow: hidden;

        &.del-key {
          width: 100%;
          height: 100%;
          background-color: #d1d5db;
          background-image: url('../assets/idcard_key2.png');
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
    }
  }
}
</style>
